module.exports = __webpack_public_path__ + "img/session-timed-out.4172c8bc.webp";